import React, { Component } from 'react'
import './performace.scss'
import { Constants, ImageConstants } from '../../constants/constants'
import { getImageSource } from '../../utility/image-source'
import SessionCache from '../routes/session-cache'
import Path from '../routes/routes-path'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import AssessmentChart from './assessment-chart/assessment-chart'
import IMDStudents from './imd-students/imd-students'
import ClassFilter from './class-filter/class-filter'
import PerformaceReport from './performance-report/performance-report'
import EvalutionReport from './evaluation-report/evaluation-report'
import AuthenticateAPI from '../../apis/authenticate'
import IMDStudentWinners from './imd-student-winners/imd-student-winners'
import InvitePartcipants from '../dashboard/invite-participants/invite-participants'
class Performace extends Component {
  state = {
    selectedClass: 'All',
    showDetails: false
  }
  data = []
  displayScreen = 'final-assessment'
  constructor (props) {
    super(props)

    let isPasswordUpdated = SessionCache.isPasswordUpdated()
    if (!isPasswordUpdated) {
      this.props.history.replace(Path.ONBOARD)
    }
    let userName = SessionCache.getName()

    this.name = userName

    let user = SessionCache.getUser()
    this.user = user
    this.state.isQuickSurveyCompleted = user.isQuickSurveyCompleted
      ? user.isQuickSurveyCompleted
      : false
    this.state.gmcAllowed = false
    if(user.schoolInfo?.eventParticipated && user.schoolInfo?.eventParticipated.length) {
      let index = user.schoolInfo?.eventParticipated.findIndex(ep => {
        return ep.eventId === Constants.GMC_EVENT_ID
      })
      if(index > -1) {
        this.state.gmcAllowed = true
      }
    }
  }

  openInviteStudents = () => {
    this.setState({ showInviteStudents: true })
  }

  openInviteTeachers = () => {
    this.setState({ showInviteTeachers: true })
  }

  hideModal = () => {
    this.setState({
      showInviteStudents: false,
      showInviteTeachers: false
    })
  }

  onContinue = _ => {
    this.hideModal()
  }

  onSelectClass = title => {
    this.setState({
      selectedClass: title || 'All'
    }, _ => {
      const {
        showDetails, 
        showEvaluationReport, 
        showPerformanceReport,
        showWinnersList,
        gmcAllowed
      } = this.state
      const payload = {}
      if(title) payload.class = title
      if(showDetails) {
        this.imdStudents.setSelectedClass(payload)
      } else if(showEvaluationReport) {
        this.evaluationReport.getEvaluationReport(payload)
      } else if(showPerformanceReport) {
        this.performanceReport.getIMDStudentPerformanceList(payload)
      }else if(showWinnersList) {
        this.studentWinners.getIMDWinnersList(payload)
      } else {
        this.assessmentChart.getIMDReport(payload)
        this.assessmentChart.getIMDPerformaceReport(payload)
        this.assessmentChart.getIMDNationalAverage(payload)
        {!gmcAllowed &&
          this.assessmentChart.getIMDWinnersList(payload)
        }
      }
    })
  }

  viewDetails = screen => {
    this.reportScreen = screen
    if(screen === 'winners') {
      this.setState({
        showWinnersList: true
      })
      return
    }
    if (screen === 'performance') {
      this.setState({
        showPerformanceReport: true
      })
      return
    }
    if (screen === 'evaluation') {
      this.setState({
        showEvaluationReport: true
      })
      return
    }
    this.setState({
      showDetails: true
    })
  }

  onClose = _ => {
    console.log('onClose')
    this.setState({
      isQuickSurveyCompleted: true
    })
  }

  setSurveyAnswer = val => {
    this.setState({ surveyAnswer: val })
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }

  onSubmitSurvey = _ => {
    const { surveyAnswer } = this.state
    let payload = {
      surveyAnswer,
      schoolCode: this.user?.schoolInfo?.schoolCode
    }
    this.setState({
      isSurveySubmit: true
    })
    AuthenticateAPI.createQuickSurvey(payload)
      .then(response => {
        this.setState({
          isQuickSurveyCompleted: true
        }, _ => {
          this.user.isQuickSurveyCompleted = true
          SessionCache.setUser(this.user)
        })
        this.showToaster('success', 'Thank you for your survey')
      })
      .catch(err => {
        this.showToaster('failure', 'Something went wrong')
        this.setState({
          isSurveySubmit: false
        })
      })
  }

  renderQuickSurvey () {
    const { surveyAnswer, isSurveySubmit } = this.state
    return (
      <div className='quick-survey'>
        <div className='quick-survey-body'>
          <div className='survey-header-text mt-3'>
            Before viewing the Performance, Please fill this quick survey
          </div>
          <div className='pt-4'>
            <div className='pb-2'>
              Countingwell has a wonderful, blended learning product for schools
              where:
            </div>
            <ul>
              <li>Teachers can assign Math’s homework in just a few clicks</li>
              <li>Improve your students scores in Maths</li>
              <li>You get an NEP aligned product for the whole school</li>
            </ul>
            <div className='question-title'>
              Would you like to try the product for free?
            </div>
            <div className='radio-container'>
              <div
                className={`custom-radio cursor-pointer ${surveyAnswer ===
                  'yes' && 'active'}`}
                onClick={_ => this.setSurveyAnswer('yes')}
              >
                <div className='radio-button'>
                  {surveyAnswer === 'yes' && <div></div>}
                </div>
                <div className='radio-label'>Yes, Of course</div>
              </div>
              <div
                className={`custom-radio cursor-pointer ${surveyAnswer ===
                  'no' && 'active'}`}
                onClick={_ => this.setSurveyAnswer('no')}
              >
                <div className='radio-button'>
                  {surveyAnswer === 'no' && <div></div>}
                </div>
                <div className='radio-label'>Not right now</div>
              </div>
            </div>
            {surveyAnswer && (
              <div className='question-title'>
                We promise you, you will be thrilled with the outcomes
              </div>
            )}
            <div className='mt-5'>
              <button
                className={`text-right cw-btn-md cw-btn-primary ${!surveyAnswer &&
                  'cw-button-disabled'}`}
                onClick={() =>
                  !isSurveySubmit && surveyAnswer && this.onSubmitSurvey()
                }
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  goBack = _ => {
    this.setState({
      showDetails: false,
      showEvaluationReport: false,
      showPerformanceReport: false,
      showWinnersList: false
    })
  }

  openInviteStudents = () => {
    this.setState({ showInviteStudents: true })
  }

  openInviteTeachers = () => {
    this.setState({ showInviteTeachers: true })
  }

  render () {
    const {
      selectedClass,
      showDetails,
      showPerformanceReport,
      showEvaluationReport,
      showWinnersList,
      isQuickSurveyCompleted,
      gmcAllowed
    } = this.state
    console.log(isQuickSurveyCompleted)
    return (
      <div className='performance'>
        <div className='mb-5 cursor-pointer' onClick={_ => this.props.history.push({pathname: Path.STANDARD_HOMEWORK, showList: true})}>
          <img
            className='ad-banner'
            src={getImageSource(ImageConstants.AD_BANNER_1)}
          />
        </div>

        <div className='header-container'>
          {(showDetails || showEvaluationReport || showPerformanceReport || showWinnersList) && (
            <div
              className='back-icon pb-4 cursor-pointer'
              onClick={this.goBack}
            >
              <FontAwesomeIcon icon={faArrowLeft} color='#1C1C1C' />
            </div>
          )}
          <div className='pb-2 title'>
            <span className='screen-title'>
              {showDetails
                ? gmcAllowed ? 'GMC Students' : 'IMD Students'
                : showPerformanceReport
                ? 'Student Performance - Final Assessment Report'
                : showEvaluationReport
                ? 'Student Evaluation Report' 
                : showWinnersList 
                ? "Students Winners"
                : gmcAllowed ? 'GULF MATHS CHALLENGE PERFORMANCE' : 'Performance'}
            </span>
            {gmcAllowed && !showDetails && !showPerformanceReport && !showEvaluationReport && !showWinnersList && (
              <button
                className={`text-right cw-btn-md cw-btn-primary `}
                onClick={() => this.openInviteStudents()}
              >
                INVITE STUDENTS TO THE CHALLENGE
              </button>
            )}
          </div>
        </div>
        <ClassFilter
          onSelectClass={this.onSelectClass}
          selectedClass={selectedClass}
        />
        <div className='container-fluid'>
          {!showDetails && !showPerformanceReport && !showEvaluationReport && !showWinnersList && (
            <AssessmentChart
              selectedClass={selectedClass}
              ref={instance => {
                this.assessmentChart = instance
              }}
              viewDetails={this.viewDetails}
              gmcAllowed={gmcAllowed}
            />
          )}
          {showDetails && (
            <>
              <div className='mt-5'>
                <IMDStudents
                  reportScreen={this.reportScreen}
                  selectedClass={selectedClass}
                  ref={instance => {
                    this.imdStudents = instance
                  }}
                  gmcAllowed={gmcAllowed}
                />
              </div>
            </>
          )}
          {showPerformanceReport && (
            <div className='mt-5'>
              <PerformaceReport
                selectedClass={selectedClass}
                ref={instance => {
                  this.performanceReport = instance
                }}
                gmcAllowed={gmcAllowed}
              />
            </div>
          )}
          {showEvaluationReport && (
            <div className='mt-5'>
              <EvalutionReport
                selectedClass={selectedClass}
                ref={instance => {
                  this.evaluationReport = instance
                }}
                gmcAllowed={gmcAllowed}
              />
            </div>
          )}
          {showWinnersList && (
            <div className='mt-5'>
              <IMDStudentWinners
                selectedClass={selectedClass}
                ref={instance => {
                  this.studentWinners = instance
                }}
                gmcAllowed={gmcAllowed}
              />
            </div>
          )}
        </div>
        {!gmcAllowed && !isQuickSurveyCompleted && this.renderQuickSurvey()}
        {this.state.showInviteStudents && (
          <InvitePartcipants
            step='STEP 1'
            size='lg'
            type={1}
            onClose={this.hideModal}
            onContinue={this.onContinue}
          />
        )}
      </div>
    )
  }
}

export default Performace
